import React, { useState } from 'react';
import { Table, Button, Modal, Form, Input, Space, Popconfirm, Row, Col, message, Spin } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useAgeGroups } from '../../hooks/useAgeGroups';
import { addAgeGroup, updateAgeGroup, deleteAgeGroup } from '../../store/slices/ageGroupsSlice';

const AgeGroups = () => {
    const dispatch = useDispatch();
    const selectedBranch = useSelector((state) => state.branches.selectedBranch);
    const selectedPlace = useSelector((state) => state.branches.selectedPlace);
    const { ageGroups, loading, refetchAgeGroups } = useAgeGroups(selectedBranch?.id, selectedPlace?.id);
    
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingAgeGroup, setEditingAgeGroup] = useState(null);
    const [form] = Form.useForm();

    const showModal = (record = null) => {
        setEditingAgeGroup(record);
        if (record) {
            form.setFieldsValue({ name: record.name });
        } else {
            form.resetFields();
        }
        setIsModalVisible(true);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        setEditingAgeGroup(null);
        form.resetFields();
    };

    const handleSubmit = async (values) => {
        try {
            if (editingAgeGroup) {
                // Düzenleme işlemi
                await dispatch(updateAgeGroup({
                    id: editingAgeGroup.id,
                    name: values.name
                })).unwrap();
                message.success('Yaş grubu başarıyla güncellendi!');
            } else {
                // Yeni ekleme işlemi
                await dispatch(addAgeGroup({
                    branchId: selectedBranch.id,
                    placeId: selectedPlace?.id,
                    name: values.name
                })).unwrap();
                message.success('Yaş grubu başarıyla eklendi!');
            }
            refetchAgeGroups();
            handleCancel();
        } catch (error) {
            console.error('Age group operation error:', error);
            message.error(`İşlem sırasında bir hata oluştu: ${error.message || error}`);
        }
    };

    const handleDelete = async (id) => {
        try {
            await dispatch(deleteAgeGroup(id)).unwrap();
            message.success('Yaş grubu başarıyla silindi!');
            refetchAgeGroups();
        } catch (error) {
            console.error('Delete age group error:', error);
            message.error(`Silme işlemi sırasında bir hata oluştu: ${error.message || error}`);
        }
    };

    const columns = [
        {
            title: 'Yaş Grubu',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'İşlemler',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<EditOutlined />}
                        onClick={() => showModal(record)}
                    />
                    <Popconfirm
                        title="Bu yaş grubunu silmek istediğinizden emin misiniz?"
                        onConfirm={() => handleDelete(record.id)}
                        okText="Evet"
                        cancelText="Hayır"
                    >
                        <Button
                            type="primary"
                            danger
                            icon={<DeleteOutlined />}
                        />
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    // Eğer seçili branch yoksa uyarı göster
    if (!selectedBranch) {
        return (
            <div className="page-container">
                <Row gutter={[24, 24]}>
                    <Col xs={24}>
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <h3>Lütfen önce bir branş seçiniz</h3>
                            <p>Yaş gruplarını yönetmek için önce spor branşı sayfasından bir branş seçmelisiniz.</p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div className="page-container">
            <Row gutter={[24, 24]}>
                <Col xs={24}>
                    <Row justify="space-between" align="middle">
                        <Col>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={() => showModal()}
                                loading={loading}
                            >
                                Yeni Yaş Grubu
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs={24}>
                    <Table
                        columns={columns}
                        rowKey="id"
                        loading={loading}
                        dataSource={ageGroups}
                        locale={{
                            emptyText: loading ? <Spin /> : 'Henüz yaş grubu bulunmamaktadır'
                        }}
                    />
                </Col>
                <Modal
                    title={editingAgeGroup ? 'Yaş Grubu Düzenle' : 'Yeni Yaş Grubu'}
                    open={isModalVisible}
                    onCancel={handleCancel}
                    footer={null}
                >
                    <Form
                        form={form}
                        onFinish={handleSubmit}
                        layout="vertical"
                    >
                        <Row gutter={[16, 16]}>
                            <Col xs={24}>
                                <Form.Item
                                    name="name"
                                    label="Yaş Grubu"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Lütfen yaş grubunu giriniz!',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Örn: U-10, U-12, U-14" />
                                </Form.Item>
                            </Col>
                            <Col xs={24}>
                                <Form.Item>
                                    <Space>
                                        <Button onClick={handleCancel}>İptal</Button>
                                        <Button type="primary" htmlType="submit" loading={loading}>
                                            {editingAgeGroup ? 'Güncelle' : 'Ekle'}
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </Row>
        </div>
    );
};

export default AgeGroups; 